const cartResult = (cart: any) => ({
  cart,
  isPendingCart: true,
  isReservation: false,
});

const reservationResult = (reservation: any) => ({
  cart: reservation,
  isPendingCart: false,
  isReservation: true,
});

const emptyResult = () => ({
  cart: undefined,
  isPendingCart: false,
  isReservation: false,
});

export const highestPriorityCartDecider = (
  cart: any,
  inProgressReservations: any
) => {
  if (cart.status === 'pending') {
    return cartResult(cart);
  }

  if (inProgressReservations.length > 0) {
    return reservationResult(inProgressReservations[0]);
  }

  return emptyResult();
};
